import type { CityConfig } from "../city-template/types";

export const chattanoogaConfig: CityConfig = {
  city: "Chattanooga",
  state: "Tennessee",
  stateAbbr: "TN",
  slug: "chattanooga",
  route: "/cities/chattanooga",
  title: "Emergency Passport Chattanooga TN | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Chattanooga, Tennessee — as fast as 24 hours. Fast passport renewal and new passport applications for Chattanooga, Cleveland, East Brainerd, Hixson, and all Southeast Tennessee residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Chattanooga, TN",
  heroSubtitle: "Chattanooga travelers — from Volkswagen manufacturing professionals to outdoor adventure enthusiasts to Lookout Mountain families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Chattanooga%20Tennessee%20skyline%20with%20the%20Tennessee%20River%20Gorge%20cutting%20through%20the%20mountains%2C%20iconic%20Walnut%20Street%20Bridge%20visible%2C%20modern%20downtown%20buildings%20mixed%20with%20historic%20architecture%2C%20Lookout%20Mountain%20in%20the%20background%2C%20lush%20green%20forests%20and%20rolling%20hills%2C%20warm%20golden%20afternoon%20sunlight%2C%20vibrant%20Southeast%20Tennessee%20city%20atmosphere%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=chattanooga-hero-001&orientation=landscape",
  heroImageAlt: "Chattanooga Tennessee skyline with Tennessee River Gorge and Walnut Street Bridge",
  geoPosition: "35.0456;-85.3097",
  geoPlacename: "Chattanooga, Tennessee",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Nashville Passport Agency",
    address: "805 Broadway Suite 400, Nashville, TN 37203",
    distance: "Approximately 2 hours northwest of Chattanooga via I-24",
  },
  nearbyCitiesZips: [
    { name: "Chattanooga", zips: "37401, 37402, 37403, 37404, 37405, 37406, 37407, 37408, 37409, 37410, 37411, 37412, 37414, 37415, 37416, 37419, 37421, 37422, 37424, 37450" },
    { name: "East Brainerd", zips: "37421" },
    { name: "Hixson", zips: "37343" },
    { name: "Red Bank", zips: "37415" },
    { name: "East Ridge", zips: "37412" },
    { name: "Soddy-Daisy", zips: "37379" },
    { name: "Signal Mountain", zips: "37377" },
    { name: "Lookout Mountain", zips: "37350" },
    { name: "Cleveland", zips: "37311, 37312, 37320, 37323, 37364" },
    { name: "Ooltewah", zips: "37363" },
    { name: "Collegedale", zips: "37302, 37315, 37363" },
    { name: "Ringgold", zips: "30736" },
    { name: "Fort Oglethorpe", zips: "30742" },
    { name: "Rossville", zips: "30741" },
    { name: "LaFayette", zips: "30728" },
    { name: "Dunlap", zips: "37327" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Nashville Passport Agency — no 2-hour drive required" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Manufacturing & Outdoor Hub", desc: "Serving Volkswagen, outdoor adventure tourism, and Southeast Tennessee travelers" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no road trip to Nashville" },
  ],
  internalLinks: [
    { name: "Expedited passport in Nashville, TN", route: "/cities/nashville" },
    { name: "Emergency passport help in Memphis, TN", route: "/cities/memphis" },
    { name: "Urgent passport services in Knoxville, TN", route: "/cities/knoxville" },
    { name: "Tennessee passport services overview", route: "/states/tennessee" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Chattanooga, Tennessee remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Nashville Passport Agency (2 hours northwest via I-24) — Chattanooga's closest regional agency. Chattanooga residents can ship from any UPS or FedEx in Hamilton County.",
  fpcOfficeDistance: "Serving Chattanooga, East Brainerd, Hixson, Red Bank, East Ridge, Soddy-Daisy, Signal Mountain, Lookout Mountain, Cleveland, Ooltewah, Collegedale, Ringgold, Fort Oglethorpe, and all of Southeast Tennessee and North Georgia",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Chattanooga and Southeast Tennessee. From downtown Chattanooga near the Riverfront to the suburban communities of East Brainerd and Hixson — from the mountain communities of Signal Mountain and Lookout Mountain to Cleveland and Ooltewah — we serve all of Hamilton County and the surrounding region.",
  nearbyCitiesIntro: "We serve Chattanooga and all nearby communities including East Brainerd, Hixson, Red Bank, East Ridge, Soddy-Daisy, Signal Mountain, Lookout Mountain, Cleveland, Ooltewah, Collegedale, Ringgold, Fort Oglethorpe, Rossville, LaFayette, and Dunlap. We also serve North Georgia and the Chattanooga metro area.",
  howItWorksIntro: "Most Chattanooga travelers complete everything online and ship documents overnight. No need to drive 2 hours to Nashville — our couriers handle the agency hand-delivery and always pick the fastest route.",
  mistakesIntro: "Chattanooga is a major manufacturing and outdoor tourism hub with significant international travel from Volkswagen and outdoor adventure companies. Here are the most common passport mistakes we see from Southeast Tennessee travelers.",
  testimonialsIntro: "Chattanooga travelers — from Volkswagen professionals to outdoor enthusiasts to Lookout Mountain families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Chattanooga, TN? Here are the most common ones we hear from Southeast Tennessee travelers.",
  statePageRoute: "/states/tennessee",
  statePageName: "Tennessee",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 2 hours to Nashville", "Full day commitment — difficult from Chattanooga"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Nashville Passport Agency — fastest route", "No long drive required", "Perfect for manufacturing and outdoor travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Nashville Passport Agency access", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Chattanooga travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Nashville Passport Agency. Perfect for last-minute Volkswagen business trips, outdoor adventure travel, and family emergencies.",
      bullets: ["24–48 hour turnaround available", "Nashville Passport Agency via courier", "Southeast Tennessee and North Georgia support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Chattanooga adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Southeast Tennessee address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Chattanooga residents and families — including UTC students, new citizens, and Southeast Tennessee families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Chattanooga residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Chattanooga and Southeast Tennessee families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Chattanooga and Southeast Tennessee residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Chattanooga TN", description: "Urgent passport processing for Chattanooga Tennessee travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Chattanooga TN", description: "Fast passport renewal for Chattanooga Tennessee residents with a previously-issued passport." },
    { name: "First-Time Passport Chattanooga TN", description: "New passport application services for Chattanooga Tennessee residents applying for their first passport." },
    { name: "Child Passport Chattanooga TN", description: "Minor passport services for Chattanooga Tennessee families with children under 16." },
  ],
  testimonials: [
    {
      name: "Brian S.",
      location: "Chattanooga, TN",
      rating: 5,
      text: "Volkswagen business trip to Germany in 4 days and my passport was expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store on Gunbarrel and the whole process was seamless. Outstanding service.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Amanda L.",
      location: "Signal Mountain, TN",
      rating: 5,
      text: "Family hiking trip to Patagonia with 10 days notice. Four passports — two renewals and two first-time for our kids. Done in 5 days. We shipped from FedEx on Hixson Pike and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Chris M.",
      location: "Cleveland, TN",
      rating: 5,
      text: "Outdoor adventure guide conference in New Zealand with 7 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. The courier service is an absolute game-changer for Southeast Tennessee.",
      service: "Emergency Passport",
    },
    {
      name: "Karen T.",
      location: "Hixson, TN",
      rating: 5,
      text: "Lost my passport the week before a cruise to the Caribbean. Fast Passport Center replaced it in 48 hours. No way I could have driven to Nashville and back with my work schedule.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "chat-1",
      name: "Chattanooga Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "810 E 11th St",
      city: "Chattanooga",
      state: "TN",
      zip: "37403",
      phone: "(423) 266-6411",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Chattanooga, near the Riverfront",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary downtown Chattanooga acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown office workers.",
      icon: "ri-mail-line",
    },
    {
      id: "chat-2",
      name: "East Brainerd Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8552 East Brainerd Rd",
      city: "Chattanooga",
      state: "TN",
      zip: "37421",
      phone: "(423) 899-3251",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East Brainerd, approximately 8 miles east of downtown Chattanooga",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for East Brainerd, Ooltewah, and eastern Hamilton County residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "chat-3",
      name: "Hixson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5415 Highway 153",
      city: "Hixson",
      state: "TN",
      zip: "37343",
      phone: "(423) 842-4471",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Hixson, approximately 10 miles north of downtown Chattanooga",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Hixson, Red Bank, and northern Hamilton County. Good alternative for north-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "chat-4",
      name: "Cleveland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3050 peerless Rd NW",
      city: "Cleveland",
      state: "TN",
      zip: "37312",
      phone: "(423) 476-7481",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Cleveland, approximately 30 miles northeast of downtown Chattanooga",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Cleveland, Collegedale, and Bradley County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "chat-5",
      name: "Hamilton County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "625 Georgia Ave",
      city: "Chattanooga",
      state: "TN",
      zip: "37402",
      phone: "(423) 209-6500",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Chattanooga, near the courthouse",
      website: "https://hctaxcollector.org/",
      websiteLabel: "Hamilton County Clerk",
      notes: "County Clerk passport acceptance. Extended hours compared to some post office locations. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2 hour drive to Nashville", fpc: "No — ship from Chattanooga" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Chattanooga manufacturing professionals and outdoor enthusiasts often discover passport issues just before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near Brainerd Road or Hixson Pike sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Hamilton County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Chattanooga Post Office appointments fill during summer travel season and fall outdoor adventure peak. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the Drive to Nashville",
      description: "Many Chattanooga residents attempt to drive to Nashville for an emergency appointment. The 2-hour drive each way through the mountains means a half day lost — our courier service is faster and more reliable.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. International travel from Chattanooga peaks during spring and summer outdoor adventure season — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Chattanooga area or Southeast Tennessee." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near Brainerd Road or downtown Chattanooga." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Nashville Passport Agency — the closest regional agency to Chattanooga." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Chattanooga address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Chattanooga, TN?", a: "Fast Passport Center offers emergency passport processing in Chattanooga, Tennessee in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Nashville Passport Agency (2 hours northwest via I-24) — without you making the drive." },
    { q: "Does Chattanooga have a passport agency?", a: "No — Chattanooga does not have a regional passport agency. The nearest facility is the Nashville Passport Agency (approximately 2 hours northwest via I-24). Fast Passport Center's courier service means Chattanooga residents never need to make that drive." },
    { q: "Can I get an expedited passport in Cleveland, Hixson, or East Brainerd?", a: "Absolutely. Fast Passport Center serves all of Southeast Tennessee including Cleveland, Hixson, East Brainerd, Red Bank, East Ridge, Soddy-Daisy, Signal Mountain, Lookout Mountain, Ooltewah, Collegedale, Ringgold, Fort Oglethorpe, and all of Hamilton and Bradley counties. Our service works the same way everywhere." },
    { q: "What airport do Chattanooga travelers use for international flights?", a: "Chattanooga Airport (CHA) is the primary airport for Chattanooga and Southeast Tennessee. CHA offers limited international service. Most international travelers connect through Atlanta (ATL), Nashville (BNA), or Charlotte (CLT). Atlanta is only 2 hours south via I-75. Always verify passport validity for at least 6 months past your return date." },
    { q: "Can I use the Atlanta passport agency from Chattanooga?", a: "Yes. The Atlanta Passport Agency is approximately 2 hours south of Chattanooga via I-75. The Nashville Passport Agency is also 2 hours northwest via I-24. Fast Passport Center's couriers serve both agencies — we always choose the fastest option for your timeline." },
    { q: "How much does an expedited passport cost in Chattanooga, TN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Chattanooga?", a: "Walgreens, CVS, and UPS Store locations throughout Chattanooga, Hixson, and Cleveland offer passport photos. FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve University of Tennessee at Chattanooga students?", a: "Yes. Fast Passport Center serves all of Southeast Tennessee including UTC students, faculty, and staff. We understand academic conference schedules and study abroad deadlines. Our courier service is especially valuable for students who can't take a day off to drive to Nashville." },
  ],
  photoLocations: [
    { name: "Walgreens — Brainerd Road", address: "2020 E 23rd St, Chattanooga, TN 37404", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Hixson", address: "5450 Highway 153, Hixson, TN 37343", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — East Brainerd", address: "2130 Northpoint Blvd, Chattanooga, TN 37421", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS — Cleveland", address: "2620 Keith St NW, Cleveland, TN 37312", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    { name: "Tennessee DOS — Chattanooga", address: "6501 Lee Hwy, Chattanooga, TN 37421", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Tennessee Department of Safety for driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended.", featured: true },
    { name: "Tennessee DOS — Hixson", address: "5613 Highway 153, Hixson, TN 37343", hours: "Tue–Sat: 8:30AM–5:00PM", note: "Serves Hixson, Red Bank, and northern Hamilton County. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "CHA",
      name: "Chattanooga Airport",
      distance: "10 miles east of downtown Chattanooga via I-75",
      address: "1001 Airport Rd, Chattanooga, TN 37421",
      note: "Primary airport for Chattanooga and Southeast Tennessee. Limited international passenger service. Most international travel connects through Atlanta (ATL), Nashville (BNA), or Charlotte (CLT).",
      flightUrl: "https://www.chattairport.com/",
      flightLabel: "CHA Flight Info",
      featured: true,
    },
    {
      code: "ATL",
      name: "Hartsfield-Jackson Atlanta International Airport",
      distance: "Approximately 2 hours south of Chattanooga via I-75",
      address: "6000 N Terminal Pkwy, Atlanta, GA 30320",
      note: "Major alternative airport for Chattanooga travelers seeking more international routes. World's busiest airport with global connections. Delta hub with nonstop flights to Europe, Asia, and Latin America.",
      flightUrl: "https://www.atl.com/",
      flightLabel: "ATL Flight Info",
      featured: false,
    },
  ],
};